var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade add-to-cart-popin-cds",
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column align-items-stretch gap-1 flex-md-row align-items-md-center justify-content-md-between",
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("div", { staticClass: "sim" }, [
                      _c("span", {
                        staticClass:
                          "icon-sim-check icon icon-tick-circle font-size-28",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "sim-img",
                        attrs: {
                          src: _vm.selectedOfferInfo
                            ? _vm.selectedOfferInfo.offerImageUrl
                            : "",
                          alt: "",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ms-1" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "mb-0 fw-bold text-dark",
                            attrs: { id: _vm.id + "-label" },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.offerName) +
                                "\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text-gray3 mb-0 py-0 font-size-14" },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.selectedOfferInfo
                                    ? _vm.selectedOfferInfo.offerInCartLabel
                                    : ""
                                ) +
                                "\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isSub
                          ? _c("ob1-boutons", {
                              staticClass: "d-md-none",
                              attrs: {
                                label: _vm.withoutDeviceSection.button.label,
                                "is-button": false,
                                "is-primary": !_vm.isSub,
                                "is-secondary": _vm.isSub,
                                href: _vm.withoutDeviceSection.button.href,
                                "data-oevent-category":
                                  _vm.withoutDeviceSection.button.tmsDTO
                                    .tagZone,
                                "data-oevent-action":
                                  _vm.withoutDeviceSection.button.tmsDTO
                                    .tagName,
                                "data-oevent-label":
                                  _vm.withoutDeviceSection.button.href,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isSub
                    ? _c("ob1-boutons", {
                        staticClass: "d-none d-md-block",
                        attrs: {
                          label: _vm.withoutDeviceSection.button.label,
                          "is-button": false,
                          "is-primary": !_vm.isSub,
                          "is-secondary": _vm.isSub,
                          href: _vm.withoutDeviceSection.button.href,
                          "data-oevent-category":
                            _vm.withoutDeviceSection.button.tmsDTO.tagZone,
                          "data-oevent-action":
                            _vm.withoutDeviceSection.button.tmsDTO.tagName,
                          "data-oevent-label":
                            _vm.withoutDeviceSection.button.href,
                        },
                      })
                    : _c("ob1-boutons", {
                        attrs: {
                          label: _vm.withoutDeviceSection.button.label,
                          "is-button": false,
                          "is-primary": !_vm.isSub,
                          "is-secondary": _vm.isSub,
                          href: _vm.withoutDeviceSection.button.href,
                          "data-oevent-category":
                            _vm.withoutDeviceSection.button.tmsDTO.tagZone,
                          "data-oevent-action":
                            _vm.withoutDeviceSection.button.tmsDTO.tagName,
                          "data-oevent-label":
                            _vm.withoutDeviceSection.button.href,
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 pb-1",
                  class: _vm.isSub ? "pt-1" : "pt-2",
                },
                [_c("ob1-separateur", { attrs: { color: "gray4" } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "promo-block d-flex bg-gray2" }, [
                _c("div", { staticClass: "px-md-2 px-1 pt-2" }, [
                  _c("h4", {
                    staticClass: "text-dark",
                    domProps: { innerHTML: _vm._s(_vm.title) },
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "mt-1 px-0" },
                    _vm._l(_vm.advantages, function (advantage, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass:
                            "font-size-14 mb-1 d-flex align-items-center",
                        },
                        [
                          _c("span", {
                            staticClass:
                              "icon icon-checkbox-tick text-primary me-1",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-dark" }, [
                            _c("strong", {
                              domProps: { innerHTML: _vm._s(advantage) },
                            }),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-1" },
                    [
                      _c("ob1-boutons", {
                        attrs: {
                          label: _vm.withDeviceSection.button.label,
                          "is-button": false,
                          "is-wide": true,
                          "is-primary": _vm.isSub,
                          "is-secondary": !_vm.isSub,
                          href: _vm.withDeviceSection.button.href,
                          "data-oevent-category":
                            _vm.withDeviceSection.button.tmsDTO.tagZone,
                          "data-oevent-action":
                            _vm.withDeviceSection.button.tmsDTO.tagName,
                          "data-oevent-label":
                            _vm.withDeviceSection.button.href,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center d-lg-none" },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.visual.smallSrc,
                          alt: _vm.visual.alt,
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-none d-lg-block" }, [
                  _c("div", { staticClass: "d-flex h-100 align-items-end" }, [
                    _c("img", {
                      attrs: { src: _vm.visual.src, alt: _vm.visual.alt },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close pt-2 pt-md-0",
          staticStyle: { display: "block !important" },
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-close ob1-link-arrow back",
          staticStyle: { display: "none !important" },
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                        Fermer\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }